<template>
    <!-- 我的订单 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class="typeArea">
        <div class="content">
            <div class="title">
                盯舱宝
            </div>

            <!-- 筛选条件 -->
            <div class="yi">
                <el-select clearable v-model="params.shipping_company_id" placeholder="船公司">
                    <el-option
                    v-for="item in shippingList"
                    :key="item.id"
                    :label="item.name_cn + '-' + item.name_en"
                    :value="item.id"
                    >
                    </el-option>
                </el-select>
                
                <el-select clearable v-model="params.pol_id" placeholder="起运港">
                    <el-option
                    v-for="item in qiYGTitleList"
                    :key="item.id"
                    :label="item.name_cn + '-' + item.name_en"
                    :value="item.id"
                    >
                    </el-option>
                </el-select>
                <el-select 
                    clearable  
                    filterable 
                    remote
                    reserve-keyword
                    :remote-method="mdgremoteMethod"
                    :loading="mdgloading"
                    v-model="params.pod_id" 
                    placeholder="目的港">
                    <el-tabs class="mudig" v-model="mdgActiveName">
                    <el-tab-pane
                        :key="index"
                        v-for="(item,index) in muDgList"
                        :label="item.route_name"
                        :name="item.route_name"
                    >
                        <el-option-group
                        v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                        :label="it.tag_name"
                        :value="it.tag_id"
                        class="mdglist"
                        >
                        <el-option
                            v-for="(at,adx) in it.port_arr"
                            :key="adx"
                            :label="at.port_name + '-' + at.name_en"
                            :value="at.port_id"
                        >
                        </el-option>
                        </el-option-group>
                    </el-tab-pane>
                    </el-tabs>
                </el-select>
                <el-select clearable v-model="params.type" placeholder="盯舱方式">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="主动订舱" value="2"></el-option>
                    <el-option label="被动订舱" value="1"></el-option>
                </el-select>
                <el-select clearable v-model="params.statue" placeholder="盯舱状态">
                    <el-option label="待盯价" value="1"></el-option>
                    <el-option label="进行中" value="2"></el-option>
                    <el-option label="已取消" value="2"></el-option>
                </el-select>
                <div class="btns">
                    <el-button class="chongzhi" @click="chongzhi">重置</el-button>
                    <el-button class="shaixuan" @click="shaixuan">筛选</el-button>
                </div>
            </div>

            <div class="add">
                <el-button @click="add" icon="el-icon-plus">新增盯舱</el-button>
            </div>

            <!-- 表格 -->
            <el-table
                :data="tableData"
                v-loading="loading"
                style="width: 100%"
                :header-cell-style="{ background: '#f9f9f9' }"
            >
                <el-table-column prop="type" label="盯舱类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">被动订舱</span>
                        <span v-if="scope.row.type==2">主动盯舱</span>
                    </template>
                </el-table-column>
                <el-table-column prop="shipping_company.name_cn" label="船公司">
                    <template slot-scope="scope">
                        {{scope.row.shipping_company_id==0?'全部':scope.row.shipping_company.name_cn}}
                    </template>
                </el-table-column>
                <el-table-column prop="pol_name" label="起运港"> </el-table-column>
                <el-table-column prop="pod_name" label="目的港"> </el-table-column>
                <el-table-column prop="cases_gauge_type" label="箱型"> </el-table-column>
                <el-table-column prop="remark" label="盯舱周期">
                    <template slot-scope="scope">
                        {{scope.row.stare_at_start_time}}至{{scope.row.stare_at_end_time}}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.statue==1">待盯价</span>
                        <span v-if="scope.row.statue==2">进行中</span>
                        <span v-if="scope.row.statue==3">已取消</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" class="bianji" @click="edit(scope.row.id)">编辑</el-button>
                        <span class="gang">/</span>
                        <el-button @click="del(scope.row.id)" type="text" class="del">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="params.page_no"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
            </el-pagination>


        </div>
    </div>
    <Bottom />

    <!-- 新增盯舱抽屉 -->
        <el-drawer
            title="价格明细"
            :visible.sync="drawer"
            direction="rtl"
            :with-header="false"
            size="50%"
            >
            <div class="drawer-title">
                <div class="word">
                    {{title}}
                </div>
                <div class="you">
                    <div>
                        <span class="mssg">基于您的盯价设置，主动为您查询运价并实时通知</span>
                        <el-switch
                            @change="changeSwitch"
                            v-model="form.type"
                            :active-value="2"
                            :inactive-value="1"
                            class="main-el-switch"
                            :width="73"
                            active-text="主动盯舱"
                            inactive-text="被动盯舱"
                            active-color="#0073F5">
                        </el-switch>
                    </div>
                    <i @click="drawer = false" class="el-icon-close"></i>
                </div>
            </div>
            <div class="tab-det">
                <div class="CargoInformation  phone-info">
                    <div class="title">
                        船期信息
                    </div>

                    <div class="info-shang">
                        <div div class="yi1">
                            <div class="word">
                            <span>*</span>船公司
                            </div>
                            <el-select  v-model="form.shipping_company_id" placeholder="船公司">
                                <el-option
                                label="全部"
                                :value="0"
                                >
                                </el-option>
                                <el-option
                                v-for="item in shippingList"
                                :key="item.id"
                                :label="item.name_cn + '-' + item.name_en"
                                :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div div class="yi1">
                            <div class="word">
                                <span>*</span>起运港
                            </div>
                            <el-select v-model="form.pol_id" placeholder="起运港">
                                <el-option
                                v-for="item in qiYGTitleList"
                                :key="item.id"
                                :label="item.name_cn + '-' + item.name_en"
                                :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <div class="word">
                                <span>*</span>目的港
                            </div>
                            <el-select 
                                clearable  filterable
                                remote
                                reserve-keyword
                                :remote-method="mdgremoteMethod"
                                v-model="form.pod_id" placeholder="目的港">
                                <el-tabs class="mudig" v-model="mdgActiveName">
                                <el-tab-pane
                                    :key="index"
                                    v-for="(item,index) in muDgList"
                                    :label="item.route_name"
                                    :name="item.route_name"
                                >
                                    <el-option-group
                                    v-for="(it,idx) in item.tag_arr"
                                    :key="idx"
                                    :label="it.tag_name"
                                    :value="it.tag_id"
                                    class="mdglist"
                                    >
                                    <el-option
                                        v-for="(at,adx) in it.port_arr"
                                        :key="adx"
                                        :label="at.port_name + '-' + at.name_en"
                                        :value="at.port_id"
                                    >
                                    </el-option>
                                    </el-option-group>
                                </el-tab-pane>
                                </el-tabs>
                            </el-select>
                        </div>
                    </div>

                    <div class="info-shang info-shang-er">
                        <div class="yi1">
                            <div class="word">
                                <span>*</span>开航起止日期
                            </div>
                            <el-date-picker
                            :picker-options="pickerOptions"
                            value-format='yyyy-MM-dd'
                            v-model="date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div class="yi1">
                            <div class="word">
                                <span>*</span>箱型
                            </div>
                            <el-select v-model="form.cases_gauge_type" placeholder="箱型">
                                <el-option
                                    v-for="item in boxTypeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <div class="word">
                                <span>*</span>舱位类型
                            </div>
                            <el-select v-model="form.shipping_space_type" placeholder="舱位类型">
                                <el-option label="全部" value="0"></el-option>
                                <el-option label="精选运价" value="1"></el-option>
                                <el-option label="现舱市场" value="2"></el-option>
                                <!-- <el-option label="船东SPOT" value="3"></el-option> -->
                            </el-select>
                        </div>
                    </div>
                    <div class="info-shang  info-shang-er">
                        <div  class="yi1">
                            <div class="word">
                                <span>*</span>最小价格
                                <br>
                                <span class="tisji">仅设置盯舱最小价格表示要小于最小价格</span>
                            </div>
                            <el-input v-model="form.min_price" placeholder="盯价最小价格" />
                        </div>
                        <div>
                            <div class="word">
                                最大价格
                                <br>
                                <span  class="tisji">设置最大价格表示区间范围</span>
                            </div>
                            <el-input v-model="form.max_price" placeholder="盯价最大价格" />
                        </div>
                        
                    </div>
                </div>
                
                <div class="CargoInformation">
                    <div class="title">
                        盯舱设置
                    </div>

                    <div class="info-shang xia">
                        <!-- <div v-if="title == '编辑新盯舱'">
                            <div class="word">
                            预期价格
                            </div>
                            <el-input v-model="input" placeholder="请输入内容"></el-input>
                        </div> -->
                        <div>
                            <div class="word">
                                盯舱周期
                            </div>
                            <el-date-picker
                            :picker-options="pickerOptions"
                            value-format='yyyy-MM-dd'
                            v-model="cycle"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                    </div>
                </div>

                <div class="CargoInformation phone-info">
                    <div class="title">
                        推送设置
                    </div>

                    <div class="info-shang xia">
                        <div class="yi1">
                            <div class="word">
                                电子邮箱
                            </div>
                            <el-input v-model="form.email" placeholder="默认绑定的邮箱可修改"></el-input>
                        </div>
                        <div>
                            <div class="word">
                                手机号码
                            </div>
                            <el-input v-model="form.phone" placeholder="默认绑定的手机号码可修改"></el-input>
                        </div>
                    </div>
                </div>

                <!-- 盯舱方式 -->
                <div class="CargoInformation">
                    <div class="title">
                        船期信息
                    </div>
                    <div class="info-shang">
                        <div>
                            <div class="word">
                            <span>*</span>订阅方式
                            </div>
                            <el-radio-group v-model="form.pre_book" @change="changeA">
                                <el-radio :label="1">订阅</el-radio>
                                <el-radio v-if="form.type==2" :label="2">预订</el-radio>
                            </el-radio-group>
                        </div>
                    </div>

                </div>
                <div v-if="form.pre_book==2">
                    <!-- 海关编号 -->
                    <div class="customs" v-show="form.shipping_space_type!=3">
                        <div class="title">HS(海关编号)</div>
                        <div class="form-tit"><span>*</span>HS(海关编号)</div>
                        <div class="input">
                            <div
                            class="yi"
                            v-for="(item, index) in inputList"
                            :key="index"
                            >
                            <el-input  @blur="hsBlus"  v-model="item.text" placeholder="请输入"></el-input>
                            <i @click="removeRow(index)" class="el-icon-delete"></i>
                            </div>
                        </div>
                        <div class="add" @click="addRow">
                            <i class="el-icon-circle-plus-outline"></i>
                            <div>新增HS</div>
                        </div>
                    </div>

                    <!-- 箱型 -->
                    <div class="boxType">
                        <div class="title">选择箱量</div>
                        <div class="boxNum">
                            <div
                                class="box-yi"
                            >
                            <div class="box-tit"><span>*</span>{{ form.cases_gauge_type || '暂未选择箱型'}}</div>
                            <!-- :max="10" -->
                            <el-input-number
                                v-model="form.box_num"
                                :min="0"
                            ></el-input-number>
                            <!-- <div class="qian">
                                <div>单价：${{item.money || '--'}}</div>
                                <div>亏仓费：￥{{item.dead_freight || '--'}}/tue</div>
                            </div> -->
                            </div>
                        </div>
                    </div>

                    <!-- 货物信息 -->
                    <div class="CargoInformation">
                        <div class="title">货物信息</div>

                        <div class="info-shang">
                            <div>
                                <div class="word"><span>*</span>包装单位</div>
                                <el-select v-model="form.packing_unit" placeholder="请选择">
                                    <el-option
                                    v-for="item in packingList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <div class="word"><span>*</span>件数</div>
                                <el-input
                                    min='0' type="number"
                                    @blur="onBlur"
                                    v-model="form.quantity"
                                    placeholder="请输入内容"
                                ></el-input>
                            </div>
                            <div>
                                <div class="word"><span>*</span>总货重(kg)</div>
                                <el-input
                                    min='0' type="number"
                                    @blur="onBlur"
                                    v-model="form.totle_weight"
                                    placeholder="请输入内容"
                                ></el-input>
                            </div>
                            <div>
                                <div class="word"><span>*</span>体积(cbm)</div>
                                <el-input
                                    min='0' type="number"
                                    @blur="onBlur"
                                    v-model="form.totle_volume"
                                    placeholder="请输入内容"
                                ></el-input>
                            </div>
                        </div>

                        <div class="info-shang">
                            <div>
                                <div class="word"><span>*</span>唛头</div>
                                <el-input
                                    type="textarea"
                                    v-model="form.shipping_mark"
                                    placeholder="请输入内容"
                                ></el-input>
                            </div>
                            <div>
                                <div class="word"><span>*</span>货物描述</div>
                                <el-input
                                    type="textarea"
                                    v-model="form.describe"
                                    placeholder="请输入内容"
                                ></el-input>
                            </div>
                        </div>
                    </div>

                    <!-- 收发通 -->
                    <div class="CargoInformation shoufat">
                        <div class="title">收发通</div>
                        <div class="info-shang info-shoufat">
                            <div>
                            <div class="word"><span>*</span>发货人</div>
                            <el-input
                                type="textarea"
                                v-model="form.shipper_mawb"
                                placeholder="请输入内容"
                            ></el-input>
                            </div>
                            <div>
                            <div class="word"><span>*</span>收货人</div>
                            <el-input
                                type="textarea"
                                v-model="form.consignee_mawb"
                                placeholder="请输入内容"
                            ></el-input>
                            </div>
                            <div>
                            <div class="word"><span>*</span>通知人</div>
                            <el-input
                                type="textarea"
                                v-model="form.notifier_mawb"
                                placeholder="请输入内容"
                            ></el-input>
                            </div>
                        </div>
                    </div>

                    <!-- 订舱联系人 -->
                    <div class="CargoInformation phone-info">
                    <div class="title">订舱联系人</div>

                    <div class="info-shang">
                        <div class="yi1">
                        <div class="word">订舱联系人</div>
                        <el-input v-model="form.linkman" placeholder="请输入"></el-input>
                        <!-- <el-select v-model="form.linkman" placeholder="请选择">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select> -->
                        </div>
                        <div class="yi1">
                        <div class="word">联系人电话</div>
                        <el-input
                            @blur="validDianhua"
                            v-model="form.linkman_phone"
                            placeholder="请输入内容"
                        ></el-input>
                        </div>
                        <div
                        class="yi"
                        v-for="(item, index) in emailList"
                        :key="index"
                        >
                        <div class="word"><span>*</span>联系人邮箱</div>
                        <div class="ipt_del">
                            <el-input @blur="validEmsil" v-model="item.email" placeholder="请输入"></el-input>
                            <div @click="removeEmail(index)" class="delete">删除</div>
                        </div>
                        </div>
                    </div>

                    <div class="add" @click="addEmail">
                        <i class="el-icon-circle-plus-outline"></i>
                        <div>新增联系人邮箱</div>
                    </div>

                    <!-- 上传 -->

                    <div class="update"  v-show="form.shipping_space_type!=3">
                        <div class="title">上传附件</div>
                        <div class="shangchuan">
                        <div class="word">上传附件</div>
                        <div class="btn">
                            <!-- action  上传地址 -->
                            <div>
                            <el-upload
                                class="upload-demo"
                                action="https://serve.dhcang.com/api/upload/file"
                                :on-success="fujianSuccess"
                                multiple
                                :headers="headers"
                                :show-file-list="false"
                            >
                                <el-button class="sc_btn" size="small" type="primary"
                                >上传附件</el-button
                                >
                            </el-upload>
                            <div
                                class="updateList"
                                v-for="(item, index) in fujianFileList"
                                :key="index"
                            >
                                <i class="el-icon-success"></i>
                                <div class="name">{{ item.file_name }}</div>
                                <el-button class="el-butnm del" @click="download(item)" type="text">下载</el-button>
                                <el-button
                                @click="fujianRemove(index)"
                                class="el-butnm"
                                type="text"
                                >删除</el-button
                                >
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="info-shang info_phone">
                        <div class="title">订单备注</div>
                        <div>
                        <div class="word">备注信息</div>
                        <el-input
                            type="textarea"
                            v-model="form.order_remarks"
                            placeholder="请输入内容"
                        ></el-input>
                        </div>
                    </div>
                    </div>
                    <div class="info-shang"  v-show="form.shipping_space_type!=3">
                        <div>
                            <div class="word">
                            付款方式
                            </div>
                            <el-radio v-model="form.pay_method" :label="1">预付</el-radio>
                            <el-radio v-model="form.pay_method" :label="2">到付</el-radio>
                        </div>
                    </div>

                </div>


            </div>
            <div class="drawer__footer">
                <el-button class="quxiao" @click="drawer = false">取 消</el-button>
                <el-button class="dingcanggg" @click="submit">完成</el-button>
            </div>
        </el-drawer>
    </div>
</template>
    
<script>
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import { 
    basePortValidList,
    destinationPortRouteTypeValidList,
    baseCasesGaugeTypeValidList,
    baseShippingCompanyValidList,
    staringAtLists,
    staringAtAdd,
    staringAtDetail,
    staringAtEdit,
    staringAtDelete,
    dict,
} from "@/api/api";
export default {
    components:{
        Bottom,
        TopNavigation,
    },
    data() {
        return {
            mdgloading:false,
            form:{
                type:1, // 盯舱方式：1被动订舱、2主动盯舱、0或空字符串表示全部
                shipping_company_id:0,
                pol_id:'',
                pod_id:'',
                cases_gauge_type:'',
                etd_start:'',
                etd_end:'',
                stare_at_start_time:'',
                stare_at_end_time:'',
                min_price:'',
                max_price:'',
                ding:1,
                email:'',
                // 预订参数
                packing_unit: "", // 包装单位
                quantity: "", // 件数
                totle_weight: "", // 总货重（kgs）
                totle_volume: "", // 体积（cbm）
                describe: "", // 货物描述
                shipping_mark: "", // 唛头
                linkman: "", // 订舱联系人
                linkman_phone: "", // 订舱联系人电话
                linkman_email: [], // 订舱联系人邮箱，如：["邮箱一","邮箱二"]
                shipper_mawb: "", // 发货人信息
                consignee_mawb: "", // 收货人信息
                notifier_mawb: "", // 通知人信息
                order_remarks: "", // 备注
                hs: [], // HS海关编码，如：["编码一","编码二"]
                box_num: '', // 箱量
                files: [
                // {type:1,file_name:'',file_url:'',file_type:''},
                // {type:2,file_name:'',file_url:'',file_type:''},
                ], // 附件，如：[{"type":"文件类型：1订单附件、2订单委托书","file_name":"文件名称","file_url":"文件地址","file_type":"文件类型：image、pdf、word等"}]
                pay_method:1,//付款方式
                shipping_space_type:'0',
            },
            date:'',
            cycle:'',
            headers:{
                'token':localStorage.getItem('token')
            },
            // 新增盯舱抽屉状态
            drawer: false,
            // 主动被动
            value:true,
            params:{
                page_no:1,
                page_size:10,
                type:'', // 盯舱方式：1被动订舱、2主动盯舱、0或空字符串表示全部
                shipping_company_id:'',
                pol_id:'',
                pod_id:'',
                statue:'',
            },
            tableData:[],
            total:0,
            boxTypeList: [],
            // 起运港列表
            qiYGTitleList: [],
            muDgList: [],
            mdgActiveName: "",
            shippingList:[],
            title:'新增盯舱',
            // 筛选时候加载
            loading:false,

            // 预订参数
            // 海关编号
            inputList: [{ text: "" }],
            emailList: [{ email: "" }],
            // 上传文件列表
            fujianFileList: [],
            weituoshuFileList: [],
            // 包装单位列表
            packingList: [],
            pickerOptions:{
                disabledDate(time) {
                    //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
                    return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7;
                    // return time.getTime() < Date.now() - 8.64e7;
                }
            },
        }
    },
    methods: {
        changeSwitch(){
            if(this.form.type==1){
               this.form.pre_book=1 
            }
        },
        addRow() {
            this.inputList.push({ text: "" }); // 添加新行
        },
        removeRow(index) {
            if(this.inputList.length==1){
                this.$message({
                    type:'error',
                    message:'最少要填写一个'
                })
            }else{
                this.inputList.splice(index, 1); // 删除指定行
            }
        },
        addEmail() {
            this.emailList.push({ email: "" }); // 添加新行
        },
        removeEmail(index) {
            if(this.emailList.length==1){
                this.$message({
                    type:'error',
                    message:'最少要填写一个'
                })
            }else{
                this.emailList.splice(index, 1); // 删除指定行
            }
        },
        // 文件上传
        fujianSuccess(res) {
        if (this.fujianFileList.length == 10) {
            this.fujianFileList.splice(0, 1);
        }
        this.fujianFileList.push({
            type: 1,
            file_name: res.data.name,
            file_url: res.data.url,
            file_type: res.data.type,
            file_uri: res.data.uri,
        });
        },
        fujianRemove(index) {
        this.fujianFileList.splice(index, 1);
        },
        weituoshuSuccess(res) {
        if (this.weituoshuFileList.length == 1) {
            this.weituoshuFileList.splice(0, 1);
        }
        // this.weituoshuFileList.push(res.data)
        this.weituoshuFileList.push({
            type: 2,
            file_name: res.data.name,
            file_url: res.data.url,
            file_type: res.data.type,
            file_uri: res.data.uri,
        });
        },
        weituoshuRemove(index) {
        this.weituoshuFileList.splice(index, 1);
        },
        handleSizeChange(val) {
            this.params.page_size=val
            this.getList()
        },
        handleCurrentChange(val) {
            this.params.page_no=val
            this.getList()
        },
        chongzhi(){
            this.params={
                page_no:1,
                page_size:10,
                type:'', // 盯舱方式：1被动订舱、2主动盯舱、0或空字符串表示全部
                shipping_company_id:'',
                pol_id:'',
                pod_id:'',
                statue:'',
            }
            this.getList()
        },
        shaixuan(){
            this.getList()
        },
        // 起运港
        async getQygList() {
            // 起运港列表
            let basePortParams = {
                page_no: 1,
                page_size: 50,
                keyword: "",
            };
            const basePortRes = await basePortValidList(basePortParams);
            if (basePortRes.code == 1) {
                this.qiYGTitleList = basePortRes.data.lists;
            }
        },
        // 目的港
        async getMdgList(e) {
            this.mdgloading = true;
            if(e==undefined){
                e=''
            }
            // 目的港列表
            const res = await destinationPortRouteTypeValidList({
                keyword:e
            });
            if (res.code==1) {
                this.muDgList=res.data
                if(res.data.length>0){
                    this.mdgActiveName=res.data[0].route_name
                }
                this.mdgloading = false
            }
        },
        mdgremoteMethod(query){
            if (query !== '') {
            setTimeout(async () => {
                this.getMdgList(query)
            }, 200);
            } else {
            this.getMdgList();
            }
        },
        // 箱型
        async getBoxTypeList() {
            // 目的港列表
            const res = await baseCasesGaugeTypeValidList();
            if (res.code==1) {
                this.boxTypeList=res.data
            }
        },
        // 获取包装单位
        async getPacking() {
            try {
                const res = await dict(
                {
                    type: "packing_unit",
                },
                this.headers
                );
                if (res.code == 1) {
                this.packingList = res.data.packing_unit;
                }
            } catch (error) {
                console.log(error, "失败");
            }
        },
        // 获取列表数据
        async getList(){
            this.loading=true
            try {
                const res = await staringAtLists(this.params,this.headers)
                if (res.code==1) {
                    this.loading=false
                    this.tableData=res.data.lists
                    this.total=res.data.count
                }
                
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 船公司
        async getShippingList() {
            const res = await baseShippingCompanyValidList();
            if (res.code == 1) {
                this.shippingList = res.data;
            }
        },
        // 添加
        add(){
            let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
            if(is_authentication!=2){
                if(is_authentication==0){
                    this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                    this.$router.push({
                        name:'UserInfo',
                        params:{
                        menuInx: '2'
                        }
                    })
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                    });
                }else{
                    this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                    this.$router.push({
                        name:'UserInfo',
                        params:{
                        menuInx: '2'
                        }
                    })
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                    });
                }
                    
                return
            }
            if(this.is_vip==0){
                this.$message({
                    type:'error',
                    message:'您还不是会员，请先购买会员'
                })
                return
            }
            this.title='新增盯舱'
            this.drawer = true

            this.date=''
            this.cycle=''

            // let email
            this.form={
                type:2, // 盯舱方式：1被动订舱、2主动盯舱、0或空字符串表示全部
                shipping_company_id:0,
                pol_id:'',
                pod_id:'',
                cases_gauge_type:'',
                etd_start:'',
                etd_end:'',
                stare_at_start_time:'',
                stare_at_end_time:'',
                min_price:'',
                max_price:'',
                pre_book:1,
                email:JSON.parse(localStorage.getItem('userInfo')).email || '1789816807@qq.com',
                phone:JSON.parse(localStorage.getItem('userInfo')).mobile || '123',
                // 预订参数
                packing_unit: "", // 包装单位
                quantity: "", // 件数
                totle_weight: "", // 总货重（kgs）
                totle_volume: "", // 体积（cbm）
                describe: "", // 货物描述
                shipping_mark: "", // 唛头
                linkman: "", // 订舱联系人
                linkman_phone: "", // 订舱联系人电话
                shipper_mawb: "", // 发货人信息
                consignee_mawb: "", // 收货人信息
                notifier_mawb: "", // 通知人信息
                order_remarks: "", // 备注
                hs: [], // HS海关编码，如：["编码一","编码二"]
                box_num: '', // 箱量
                linkman_email: [], // 订舱联系人邮箱，如：["邮箱一","邮箱二"]
                files: [
                // {type:1,file_name:'',file_url:'',file_type:''},
                // {type:2,file_name:'',file_url:'',file_type:''},
                ], // 附件，如：[{"type":"文件类型：1订单附件、2订单委托书","file_name":"文件名称","file_url":"文件地址","file_type":"文件类型：image、pdf、word等"}]
                pay_method:1,
                shipping_space_type:'0',
            }
        },
        async submit(){
            if(this.date.length>0){
                this.form.etd_start = this.date[0]
                this.form.etd_end = this.date[1]
            }else{
                this.$message({
                    type:'error',
                    message:'请选择开航起止日期'
                })
                return
            }

            if(this.cycle.length>0){
                this.form.stare_at_start_time = this.cycle[0]
                this.form.stare_at_end_time = this.cycle[1]
            }

            // 订阅还是预订
            // 如果是订阅将一些信息清空
            if(this.form.pre_book==1){
                this.form.packing_unit=''
                this.form.quantity=''
                this.form.totle_weight=''
                this.form.totle_volume=''
                this.form.describe=''
                this.form.shipping_mark=''
                this.form.linkman=''
                this.form.linkman_phone=''
                this.form.linkman_email=[]
                this.form.shipper_mawb=''
                this.form.consignee_mawb=''
                this.form.notifier_mawb=''
                this.form.order_remarks=''
                this.form.hs=[]
                this.form.files=[]
            }else{
                // 订阅 对数据进行处理
                // hs
                this.form.hs = [];
                for (let i = 0; i < this.inputList.length; i++) {
                    this.form.hs.push(this.inputList[i].text);
                }
                // linkman_email
                this.form.linkman_email = [];
                for (let i = 0; i < this.emailList.length; i++) {
                    this.form.linkman_email.push(this.emailList[i].email);
                }
                // files
                this.form.files = [];
                // 订单附件
                for (let i = 0; i < this.fujianFileList.length; i++) {
                    this.form.files.push({
                    type: 1,
                    file_name: this.fujianFileList[i].file_name,
                    file_url: this.fujianFileList[i].file_url,
                    file_uri: this.fujianFileList[i].file_uri,
                    file_type: this.fujianFileList[i].file_type,
                    });
                }
                // 委托书
                for (let i = 0; i < this.weituoshuFileList.length; i++) {
                    this.form.files.push({
                    type: 2,
                    file_name: this.weituoshuFileList[i].file_name,
                    file_url: this.weituoshuFileList[i].file_url,
                    file_type: this.weituoshuFileList[i].file_type,
                    file_uri: this.fujianFileList[i].file_uri,
                    });
                }

            }

            let api = staringAtAdd
            if(this.title=='编辑盯舱'){
                api = staringAtEdit
            }
            try {
                const res = await api(this.form,this.headers)
                if(res.code==1){
                    this.$message({
                        type:'success',
                        message:'成功'
                    })
                    
                    this.drawer = false
                    this.getList()
                    this.date=''
                    this.cycle=''
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        changeA(){
            console.log(1111,this.form.pre_book);
            let a =this.form.pre_book
            this.form.pre_book = a
        },
        // 编辑
        async edit(index){
            this.title='编辑盯舱'
            this.drawer = true

            // 获取详情
            try {
                const res = await staringAtDetail({
                    id:index
                },this.headers)
                if(res.code==1){
                    this.form = res.data
                    this.form.id = res.data.id
                    this.form.type = res.data.type
                    this.form.shipping_company_id = res.data.shipping_company_id
                    this.form.pol_id = res.data.pol_id
                    this.form.pod_id = res.data.pod_id
                    this.form.cases_gauge_type = res.data.cases_gauge_type
                    this.form.min_price = res.data.min_price
                    this.form.max_price = res.data.max_price
                    
                    this.form.etd_end = res.data.etd_end
                    this.form.etd_start = res.data.etd_start
                    this.form.stare_at_start_time = res.data.stare_at_start_time
                    this.form.stare_at_end_time = res.data.stare_at_end_time
                    this.form.pre_book = res.data.pre_book

                    this.form.email = res.data.email
                    this.form.shipping_space_type = String(res.data.shipping_space_type)
                    this.form.phone = res.data.phone

                    this.date = [res.data.etd_start,res.data.etd_end]
                    this.cycle = [res.data.stare_at_start_time,res.data.stare_at_end_time]
                    // 预订参数
                    if(res.data.pre_book==2){
                        this.form.packing_unit=res.data.packing_unit // 包装单位
                        this.form.quantity=res.data.quantity// 件数
                        this.form.totle_weight=res.data.totle_weight // 总货重（kgs）
                        this.form.totle_volume=res.data.totle_volume // 体积（cbm）
                        this.form.describe=res.data.describe // 货物描述
                        this.form.shipping_mark=res.data.shipping_mark // 唛头
                        this.form.linkman=res.data.linkman // 订舱联系人
                        this.form.linkman_phone=res.data.linkman_phone // 订舱联系人电话
                        this.form.shipper_mawb=res.data.shipper_mawb // 发货人信息
                        this.form.consignee_mawb=res.data.consignee_mawb // 收货人信息
                        this.form.notifier_mawb=res.data.notifier_mawb // 通知人信息
                        this.form.order_remarks=res.data.order_remarks // 备注
                        this.form.hs=res.data.hs // HS海关编码，如：["编码一","编码二"]
                        this.form.box_num=res.data.box_num // 箱量
                        this.form.linkman_email=res.data.linkman_email// 订舱联系人邮箱，如：["邮箱一","邮箱二"]
                        this.form.files=res.data.files  // 附件，如：[{"type":"文件类型：1订单附件、2订单委托书","file_name":"文件名称","file_url":"文件地址","file_type":"文件类型：image、pdf、word等"}]
                        this.form.pay_method=res.data.pay_method

                        this.inputList = []
                        for (let i = 0; i < res.data.hs.length; i++) {
                            this.inputList.push({text:res.data.hs[i]})
                        }

                        this.emailList = []
                        for (let i = 0; i < res.data.linkman_email.length; i++) {
                            this.emailList.push({email:res.data.linkman_email[i]})
                        }

                        this.fujianFileList = res.data.files
                    }else{
                        this.form.pay_method=1
                        this.form.packing_unit="" // 包装单位
                        this.form.quantity="" // 件数
                        this.form.totle_weight="" // 总货重（kgs）
                        this.form.totle_volume="" // 体积（cbm）
                        this.form.describe="" // 货物描述
                        this.form.shipping_mark="" // 唛头
                        this.form.linkman="" // 订舱联系人
                        this.form.linkman_phone="" // 订舱联系人电话
                        this.form.shipper_mawb="" // 发货人信息
                        this.form.consignee_mawb="" // 收货人信息
                        this.form.notifier_mawb="" // 通知人信息
                        this.form.order_remarks="" // 备注
                        this.form.hs=[] // HS海关编码，如：["编码一","编码二"]
                        this.form.box_num='' // 箱量
                        this.form.linkman_email=[] // 订舱联系人邮箱，如：["邮箱一","邮箱二"]
                        this.form.files=[] // 附件，如：[{"type":"文件类型：1订单附件、2订

                        this.inputList = [{text:''}]
                        this.emailList = [{email:''}]
                        this.fujianFileList = []
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 删除
        del(index){
            this.$confirm('此操作将删除此数据, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                try {
                        const res = await staringAtDelete({
                            id:index
                        },this.headers)
                        if(res.code==1){
                            this.$message({
                                type:'success',
                                message:'删除成功'
                            })
                            this.getList()
                        }else{
                            this.$message({
                                type:'error',
                                message: res.msg
                            })
                        }
                    } catch (error) {
                        console.log(error,'失败');
                    }
				}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
        },
        // 校验邮箱
        validEmsil(e) {
            let emial = e.target.value
            if(emial==''){
                return
            }
            if (emial == "" || emial == undefined) {
                this.$message({
                message: "请输入邮箱地址",
                type: "error",
                });
                return false;
            } else if (
                !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                emial
                )
            ) {
                this.$message({
                // duration:0,
                message: "请输入正确的邮箱地址",
                type: "error",
                });
                return false;
            }
            return true;
        },
        // 校验手机号
        validDianhua() {
            let dianhua = this.form.linkman_phone
            if(dianhua==''){
                return
            }
            if (!/^1[3-9]\d{9}$/.test(dianhua)) {
                // this.$toast('请输入正确的手机号')
                // alert('1121')
                // this.$message.error("请输入正确的手机号");
                this.$message({
                // duration:0,
                message: "请输入正确的手机号",
                type: "error",
                });
                return false;
            }
            return true;
        },
        // 输入的数字大于0
        onBlur(e){
            if(e.target.value == ''){
                return
            }
            if(!/\d$/.test(e.target.value)){
                this.$message({
                type:'error',
                message:'输入的内容应为数字'
                })
            }
        },
        hsBlus(e){
            if(e.target.value == ''){
                return
                }
            if(!/^[1-9]\d{5}$/.test(e.target.value)){
                this.$message({
                type:'error',
                message:'输入的内容应为六位数字'
                })
            }
        },
        // 下载
        download(e){
            const link = document.createElement('a');
            link.href = e.file_url;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
    mounted(){
        this.getList()
        this.getQygList();
        this.getMdgList();
        this.getBoxTypeList();
        this.getShippingList();
        this.getPacking();

        // this.form.email = JSON.parse(localStorage.getItem('userInfo')).email
        // this.form.phone = JSON.parse(localStorage.getItem('userInfo')).mobile
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    margin-top: 26px;
    margin-bottom: 26px;
}


.content{
    border-radius: 12px 12px 12px 12px;
    background: #fff;

    margin-bottom: 32px;

    padding: 32px;

    .title{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        margin-bottom: 10px;
    }

    ::v-deep .el-tabs__item.is-active {
        color: #0073F5;//选中
    }
    
    ::v-deep .el-tabs__item:hover {
        color: #0073F5;//hover
        // cursor: pointer;
    }
    // 普通字体颜色
    ::v-deep .el-tabs__item {
        color: #606260;//悬浮
        // cursor: pointer;
        font-size: 18px;
    }

    // 下划线颜色
    ::v-deep .el-tabs__active-bar {
        background-color: #0073F5;
    }

    .yi{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        margin-top: 4px;

        .btns{
            width: 360px;
            height: 40px;
            text-align: right;

            .chongzhi{
                width: 100px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #999999;
                font-style: normal;
                text-transform: none;
            }

            .shaixuan{
                width: 100px;
                height: 40px;
                background: #0073F5;
                border-radius: 8px 8px 8px 8px;
                border: 0;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #fff;
                font-style: normal;
                text-transform: none;
            }
        }

        :deep(.el-input){
            width: 360px;
            height: 40px;
            margin-bottom: 16px;

            input{
                width: 360px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;

                border: 0;
            }
        }
        :deep(.el-date-editor){
            width: 360px;
            height: 40px;
            background: #F9F9F9 ;
            border-radius: 8px 8px 8px 8px;
            border: 0;
            // margin-bottom: 16px;

            .el-range-input{
                background: #f9f9f9 ;
            }
        }
    }

    

    .table{
        width: 100%;
        border-spacing: 0;

        border-bottom: solid 1px #eee;

        margin-top: 4px;

        .theader{
            height: 48px;
            background: #F9F9F9;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;
        
        }
        .first{
            padding-left: 24px;
            // width: 320px;
        }
        .tbody{
            height: 68px;
            background: #fff;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;

            .update{
                color: #0073F5;
                font-size: 14px;
            }

            .del{
                color: #FE3300;
                font-size: 14px;
            }

            span{
                color: #999;
            }
        }
    }

    .el-pagination{
        text-align: right;
        margin-top: 80px;
    }
}

.add{
    margin-bottom: 20px;
    .el-button{
        width: 108px;
        height: 40px;
        background: #EDF6FF;
        border-radius: 8px 8px 8px 8px;
        border: 0;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #0073F5;
        font-style: normal;
        text-transform: none;
    }
}

.el-drawer{
  .drawer-title{
    width: 100%;
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span{
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    .you{
        display: flex;
        align-items: center;
        .mssg{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            margin-right: 8px;
        }
    }

    i{
      font-size: 28px;
      color: #999;
      cursor: pointer;

      margin-left: 24px;
    }
  }
  .tab-det{
    padding: 32px 32px 0 32px;
  }

  .tab-tit{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }


  .drawer__footer{
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;

    .quxiao{
      width: 100px;
      height: 40px;
      background: #F9F9F9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 16px;
    }

    .dingcanggg{
      width: 100px;
      height: 40px;
      background: #0073F5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      border: 0;
      font-size: 14px;
      margin-right: 32px;
    }
  }
}

// 主动被动
::v-deep .clearPadding .vxe-cell {
    padding: 0;
}
::v-deep .clearPaddingLeft .vxe-cell {
    padding-left: 0px;
}
::v-deep {
    .main-el-switch {
        position: relative;
        .el-switch__core {
            height: 24px;
            border-radius: 12px;
            &:after {
                left: 4px;
                top: 3px;
            }
        }
        &.el-switch {
            &.is-checked {
                .el-switch__core {
                    &:after {
                    margin-left: -20px;
                    left: 100%;
                    }
                }
            }
        }
        &.is-checked {
            .el-switch__label--left {
                opacity: 0;
            }
            .el-switch__label--right {
                opacity: 1;
            }
        }
        .el-switch__label {
            position: absolute;
            top: 0;

            display: flex;
            align-items: center;

            span{
                font-size: 10px;
            }
        }
        .el-switch__label--left {
            right: 0;
            color: #999;
            z-index: 1;
            margin-right: 8px;
        }
        .el-switch__label--right {
            left: 0;
            color: #fff;
            opacity: 0;
            margin-left: 8px;
        }
    }
}

.CargoInformation{
//   height: 401px;
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;
  box-sizing: border-box;

  .title{
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .info-shang{
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .word{
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-style: normal;
      text-transform: none;
      color: #606260;

      span{
        color: #FE3300;
      }

      .tisji{
        font-size: 12px;
        color: #999;
      }

    }

    // .tishi{
    //     width: 260px;
    // }

    :deep(.el-input){
      input{
        width: 260px;
        height: 40px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }

    :deep(.el-date-editor){
        width: 260px;
        height: 40px;
        background: #F9F9F9 ;
        border-radius: 8px 8px 8px 8px;
        border: 0;
        .el-range-input{
            background: #f9f9f9 ;
        }
    }

    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 425px;
        height: 160px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
  }

  .xia{
    justify-content: start;
    .el-input{
        margin-right: 8px;
    }
  }
}

.gang {
    color: #999999;
    font-size: 14px;
}

.bianji,.bianji:hover {
    color: #0073f5;
    font-size: 14px;
}
.del,.del:hover {
    font-size: 14px;
    color: #fe3300;
}

.mudig {
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  width: 500px;
  .mdglist {
    :deep(.el-select-group) {
      display: flex;
      flex-wrap: wrap;
    }
  }
  :deep(.el-select) {
    ul.el-select-group {
      display: flex;
    }
  }
}

.customs {
  // height: 217px;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;

  .title {
    width: 109px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
  }

  .form-tit {
    width: 92px;
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    font-style: normal;
    text-transform: none;

    margin-top: 24px;
    margin-bottom: 12px;

    span {
      color: #fe3300;
    }
  }

  .input {
    display: flex;
    flex-wrap: wrap;
    .yi {
      display: flex;
      align-items: center;
      margin-right: 24px;
      margin-bottom: 20px;
    }

    :deep(.el-input) {
      width: 242px;
      input {
        width: 242px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }

    .el-icon-delete {
        color: #606260;
      margin-left: 8px;
      cursor: pointer;

      font-size: 16px;
    }
  }

  .add {
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    width: 120px;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
      font-size: 16px;
    }
  }
}

.boxType {
  // height: 218px;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;
  .title {
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    // margin-top: 32px;
  }

  .boxNum {
    margin-top: 24px;

    display: flex;
    .box-yi {
      margin-right: 24px;
      .box-tit {
        margin-bottom: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        font-style: normal;
        text-transform: none;
        color: #606260;
        span {
          color: #fe3300;
        }
      }

      .el-input-number {
        width: 242px;
        height: 44px;
      }

      .qian {
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #999999;
        font-style: normal;
        text-transform: none;

        display: flex;
        div {
          margin-right: 16px;
        }
      }
    }
  }
}

.phone-info {
  height: 100%;
  .info-shang {
    flex-wrap: wrap;
    justify-content: start;

    .yi1 {
      margin-right: 24px;
    }
    .yi {
      margin-bottom: 20px;
      margin-right: 24px;

      :deep(.el-input) {
        width: 226px;
        input {
          width: 226px;
          height: 44px;
          background: #f9f9f9;
          border-radius: 8px 8px 8px 8px;
          border: 0;
        }
      }
    }
    .yi2 {
      margin-right: 0px;
    }
    .delete {
      margin-right: 4px;
      font-size: 16px;

      cursor: pointer;

      font-size: 14px;
      color: #fe3300;

      line-height: 44px;
    }

    .ipt_del {
      display: flex;
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
    }
  }
  .add {
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    width: 120px;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
  }

  .info_phone {
    .word {
      margin-top: 24px;
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 860px;
      }
    }
  }
}

.update {
  .title {
    margin-top: 24px;
    margin-bottom: 24px;
    margin-top: 32px;
  }
  .shangchuan {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }

  .btn {
    display: flex;
    margin-top: 12px;
    .sc_btn {
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      color: #0073f5;
      font-size: 14px;
      border: 0;
    }
  }

  .upload-demo {
    width: 266px;
    margin-right: 24px;
  }

  .updateList {
    // margin-top: 12px;

    display: flex;
    align-items: baseline;

    i {
      font-size: 16px;
      color: #00b53c;
      margin-right: 9px;
    }

    .name {
      width: 130px;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;
    }

    .el-butnm {
      color: #fe3300;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      font-style: normal;
      text-transform: none;

      height: 24px;
    }

    .del {
      color: #0073f5;
      margin-left: 53px;
    }
  }
}

// 单选按钮警告错误
::v-deep .el-radio__original {
  display: none !important;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}

// ::v-deep .el-radio input[aria-hidden="true"] {
//   display: none !important;
// }
 
// ::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
//   box-shadow: none !important;
// }


</style>